import React, { useRef, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { SelectOption } from 'contracts/Common';
import Select from './Select';
import * as S from './styles';

const options: SelectOption[] = [
  {
    value: '/configuracoes/historico-alertas',
    label: 'Histórico de Alertas',
  },
  {
    value: '/configuracoes/checklist/modelos',
    label: 'Modelos de Checklist',
  },
  {
    value: '/configuracoes/checklist/usuarios',
    label: 'Usuários de Checklist',
  },
  {
    value: '/configuracoes/clientes',
    label: 'Clientes',
  },
  {
    value: '/configuracoes/clientes/usuarios',
    label: 'Usuários de Clientes',
  },
  {
    value: '/configuracoes/transportadoras',
    label: 'Transportadoras',
  },
  {
    value: '/configuracoes/transportadoras/usuarios',
    label: 'Usuários de Transportadoras',
  },
  {
    value: '/configuracoes/areas',
    label: 'Áreas - Gestão de Docas',
  },
  {
    value: '/configuracoes/armazens',
    label: 'Armazéns',
  },
  {
    value: '/configuracoes/armazens/usuarios',
    label: 'Usuários de Armazéns',
  },
  {
    value: '/configuracoes/automacao-apontamentos',
    label: 'Automação de apontamentos',
  },
  {
    value: '/configuracoes/bloqueio-de-horarios',
    label: 'Bloqueio de Horários',
  },
  {
    value: '/configuracoes/tipos-veiculos',
    label: 'Tipos de Veículos',
  },
  {
    value: '/configuracoes/tipos-cargas',
    label: 'Tipos de Cargas',
  },
  {
    value: '/configuracoes/setups-veiculos',
    label: 'Setups de Veículos',
  },
  {
    value: '/configuracoes/tipos-operacoes',
    label: 'Tipos de Operações',
  },
  {
    value: '/configuracoes/justificativas-cancelamento',
    label: 'Justificativas de Cancelamento',
  },
  {
    value: '/configuracoes/administradores',
    label: 'Administradores',
  },
];

export const SettingsMenu: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const location = useLocation();
  const navigate = useNavigate();

  const onDestinationChange = useCallback(
    (option: SelectOption | null): void => {
      if (!option?.value) return;
      if (option.value === location.pathname) return;
      navigate(option.value as string);
    },
    [location.pathname, navigate]
  );

  const onNavigate = useCallback((): void => {
    const currentOption = options.find((o) => o.value === location.pathname);
    if (currentOption) {
      formRef.current?.setFieldValue('destination', currentOption);
    }
  }, [location.pathname]);

  useEffect(() => {
    onNavigate();
  }, [onNavigate]);

  return (
    <S.MenuContainer>
      <S.Label>
        <S.SettingsIcon /> Configurações:
      </S.Label>
      <Form ref={formRef} onSubmit={() => {}}>
        <Select
          name="destination"
          options={options}
          onChange={onDestinationChange}
        />
      </Form>
    </S.MenuContainer>
  );
};
